module.exports = __WEBPACK_EXTERNAL_MODULE_37__;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 37
// module chunks = 9